import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/countryState/importer/countryStateImporterActions';

export default importerReducers(actions);
